import http from "./http";

/**
 * Service for the /productos/listas-precios API.
 * All calls go through the central `http` instance — never raw axios.
 *
 * `obtenerListasPrecio` is the single source of truth for fetching the raw
 * list of price lists. It is shared by store/modules/productos.js
 * (action getListasPrecio) and store/modules/listasPrecio.js (action
 * getListasPrecios) — both used to hit this same endpoint independently
 * with their own axios calls, causing duplicate requests when dispatched
 * around the same time.
 *
 * Single-flight: while a request is in progress, concurrent callers reuse
 * the same promise instead of firing a new HTTP request each. Once the
 * request settles, the next call fetches fresh data again — this does NOT
 * introduce a persistent cache, it only dedupes concurrent calls.
 */
let solicitudEnCurso = null;

const obtenerListasPrecio = () => {
  if (!solicitudEnCurso) {
    solicitudEnCurso = http
      .get("productos/listas-precios")
      .then((response) => response.data)
      .finally(() => {
        solicitudEnCurso = null;
      });
  }
  return solicitudEnCurso;
};

export default {
  obtenerListasPrecio,
};
